import { Avatar, AvatarFallback } from '@/components/ui/avatar';

interface TypingIndicatorProps {
  senderName?: string;
  senderAvatar?: string;
}

export function TypingIndicator({ senderName, senderAvatar }: TypingIndicatorProps) {
  return (
    <div className="flex items-start gap-2 py-2">
      {/* Avatar */}
      <Avatar className="h-8 w-8 flex-shrink-0">
        <AvatarFallback className="text-xs font-semibold bg-slate-200 text-slate-600">
          {senderAvatar ||
            senderName
              ?.split(' ')
              .map((n) => n[0])
              .join('')
              .toUpperCase()
              .slice(0, 2) ||
            'U'}
        </AvatarFallback>
      </Avatar>

      {/* Typing Indicator Bubble */}
      <div className="flex flex-col gap-1">
        {senderName && (
          <span className="text-xs px-1 text-slate-500">
            {senderName}
          </span>
        )}
        <div className="flex items-center gap-3 rounded-2xl rounded-bl-md px-4 py-3 max-w-16 bg-slate-100">
          <div className="flex gap-1">
            <span
              className="w-2 h-2 rounded-full animate-bounce bg-slate-500"
              style={{ animationDelay: '0ms' }}
            />
            <span
              className="w-2 h-2 rounded-full animate-bounce bg-slate-500"
              style={{ animationDelay: '150ms' }}
            />
            <span
              className="w-2 h-2 rounded-full animate-bounce bg-slate-500"
              style={{ animationDelay: '300ms' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
